module.exports = __webpack_public_path__ + "img/person.e6e88495.png";